var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"root"},[_c('v-col',[_c('v-skeleton-loader',{staticClass:"header-loading-1",attrs:{"loading":_vm.loading,"type":"heading"}},[_c('h1',[_vm._v(_vm._s(_vm.title))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }